<template>
  <div ref="chartCon" class="echarts-con" id="upload"></div>
</template>
<script>
import "echarts-liquidfill";
export default {
  name: "liquidfill",
  props: {
    percentage: {
      type: Number,
      default: 0,
    },
    pageType: {
      type: String,
    },
    color: {
      type: String,
      default: "#1290C9",
    },
  },
  data() {
    return {
      myChart: null,
    };
  },
  computed: {
    isSmallScreen() {
      return true;
    },
  },
  watch: {
    isSmallScreen: function (val) {
      this.initEcharts();
      this.resizeChart();
    },
    percentage: {
      handler(newVal, oldVal) {
        console.log("percentage", newVal, "-", oldVal);
        this.percentage = newVal;
        if (typeof newVal == "number") {
          this.$nextTick(() => {
            this.initEcharts();
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initEcharts();
    });
  },
  beforeDestroy() {},
  methods: {
    initEcharts() {
      if (!this.myChart) {
        this.myChart = this.$echarts.init(this.$refs.chartCon, null, {
          renderer: "svg",
        });
      }
      let bgColor = "#ffffff";
      let fillColor =
        this.pageType == "leads"
          ? "rgba(142, 134, 221, 0.11)"
          : "rgba(188, 222, 242, 0.1)";
      let rate = (this.percentage / 100).toFixed(2);
      let option = {
        series: [
          {
            type: "liquidFill",
            radius: this.isSmallScreen ? "130px" : "130px",
            center: ["50%", "50%"],
            data: [rate, rate, rate], // data个数代表波浪数
            backgroundStyle: {
              color: bgColor,
            },
            // 修改波浪颜色
            color: [fillColor],
            label: {
              normal: {
                insideColor: "transparent", // 避免文字显示为白色
                formatter: this.percentage + "%",
                textStyle: {
                  fontSize: this.isSmallScreen ? 30 : 46,
                  fontFamily: "Arial Bold",
                  fontWeight: "normal",
                  color: this.color, // 设置字体颜色
                },
              },
            },
            outline: {
              show: false,
            },
          },
          {
            type: "pie",
            center: ["50%", "50%"],
            radius: ["93%", "93%"],
            hoverAnimation: false,
            data: [
              {
                name: "",
                value: this.percentage.toFixed(0),
                labelLine: {
                  show: false,
                },
                itemStyle: {
                  borderColor: this.color,
                  borderWidth: this.isSmallScreen ? 7 : 10,
                  borderJoin: "round",
                  opacity: 1,
                },
                emphasis: {
                  disabled: true,
                },
              },
              {
                // 画剩余的刻度圆环
                name: "",
                value: (100 - this.percentage).toFixed(0),
                itemStyle: {
                  borderColor: this.color,
                  borderWidth: this.isSmallScreen ? 7 : 10,
                  borderJoin: "bevel",
                  opacity: 1,
                },
                label: {
                  show: false,
                },
                labelLine: {
                  show: false,
                },
                emphasis: {
                  disabled: true,
                },
              },
            ],
          },
        ],
      };

      this.myChart.setOption(option);
    },
    resizeChart() {
      // 调用 ECharts 实例的 resize 方法，动态调整图表大小
      if (this.myChart) {
        this.myChart.resize();
      }
    },
  },
};
</script>
<style scoped>
.this-div {
  width: 100%;
  height: 100%;
  position: relative;
}
.echarts-con {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
